import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-120">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/rTBU1M16EuiVcoKrrSFt1A/heylloyd-image-1772459194281.png')`
    }} data-id="element-121" />

      {/* Dark overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50" data-id="element-122" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40" data-id="element-123" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-20" data-id="element-124">
        <div className="max-w-2xl" data-id="element-125">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#C9A84C]/10 border border-[#C9A84C]/30 px-4 py-1.5 mb-6" data-id="element-126">
            <span className="w-2 h-2 rounded-full bg-[#C9A84C] animate-pulse" data-id="element-127" />
            <span className="text-[#C9A84C] font-body text-xs tracking-widest uppercase font-medium" data-id="element-128">
              Boxeo · MMA · K1
            </span>
          </div>

          {/* H1 */}
          <h1 className="font-heading font-bold text-white uppercase leading-none mb-6" data-id="element-129">
            <span className="block text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tight mb-2" data-id="element-130">
              Entrena Boxeo / Kickboxing / MMA
            </span>
            <span className="block text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tight" data-id="element-131">
              en <span className="gold-underline text-[#C9A84C]" data-id="element-132">Tu Zona</span>
            </span>
          </h1>

          {/* Subtitle */}
          

          {/* Bullets */}
          <ul className="space-y-3 mb-10" data-id="element-133">
            <li className="flex items-center gap-3" data-id="element-134">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#C9A84C]/20 border border-[#C9A84C] flex items-center justify-center" data-id="element-135">
                <CheckIcon size={11} className="text-[#C9A84C]" data-id="element-136" />
              </span>
              <span className="font-body text-gray-200 text-sm sm:text-base" data-id="element-137">
                Grupos por nivel (principiantes a avanzados)
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-138">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#C9A84C]/20 border border-[#C9A84C] flex items-center justify-center" data-id="element-139">
                <CheckIcon size={11} className="text-[#C9A84C]" data-id="element-140" />
              </span>
              <span className="font-body text-gray-200 text-sm sm:text-base" data-id="element-141">
                Entrenadores atentos + ambiente de equipo
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-142">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#C9A84C]/20 border border-[#C9A84C] flex items-center justify-center" data-id="element-143">
                <CheckIcon size={11} className="text-[#C9A84C]" data-id="element-144" />
              </span>
              <span className="font-body text-gray-200 text-sm sm:text-base" data-id="element-145">
                Personaliza tu nutrición + plan entrenamiento
              </span>
            </li>
          </ul>

          {/* CTA */}
          <a href="#precios" className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-8 py-4 text-lg tracking-widest uppercase transition-all duration-200 shadow-lg shadow-[#C9A84C]/25 hover:shadow-[#C9A84C]/40 hover:scale-105" data-id="element-146">
            Ver Precios y Horarios
            <ChevronDownIcon size={20} className="text-black" data-id="element-147" />
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 animate-bounce" data-id="element-148">
        <span className="text-gray-500 text-xs font-body tracking-widest uppercase" data-id="element-149">
          Scroll
        </span>
        <ChevronDownIcon size={20} className="text-[#C9A84C]" data-id="element-150" />
      </div>
    </section>;
}